import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabDirective, TabsModule } from 'ngx-bootstrap/tabs';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { RouterModule } from '@angular/router';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { User } from '../../../models/users/user.model';
import { UserCurrencyType } from '../../../enums/users/user-currency-type.enum';
import { UserBoosterType } from '../../../enums/users/user-booster-type.enum';
import { UserAccountType } from '../../../enums/users/user-account-type.enum';
import { ModalsService } from '../../../services/modals.service';
import { DateService } from '../../../services/date.service';
import { AlertsService } from '../../../services/alerts.service';
import { ApiUsersService } from '../../../services/users/api/api-users.service';
import { UserAddExperienceModalComponent } from '../modals/user-add-experience-modal/user-add-experience-modal.component';
import { UserAddCurrencyModalComponent } from '../modals/user-add-currency-modal/user-add-currency-modal.component';
import { UserAddBoosterModalComponent } from '../modals/user-add-booster-modal/user-add-booster-modal.component';
import { UserTransactionsTabComponent } from './tabs/user-transactions-tab/user-transactions-tab.component';
import { UserMatchsTabComponent } from './tabs/user-matchs-tab/user-matchs-tab.component';
import { UserLogsTabComponent } from './tabs/user-logs-tab/user-logs-tab.component';
import { UserSessionsTabComponent } from './tabs/user-sessions-tab/user-sessions-tab.component';
import { UserLeaguesTabComponent } from './tabs/user-leagues-tab/user-leagues-tab.component';
import { UserTournamentsTabComponent } from './tabs/user-tournaments-tab/user-tournaments-tab.component';
import { UserMessagesTabComponent } from './tabs/user-messages-tab/user-messages-tab.component';
import { UserReportsTabComponent } from './tabs/user-reports-tab/user-reports-tab.component';
import { UserCollectionsTabComponent } from './tabs/user-collections-tab/user-collections-tab.component';

@Component({
  templateUrl: 'user-details.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TabDirective, CollapseModule, TabsModule,
    UserAddExperienceModalComponent,
    UserAddCurrencyModalComponent,
    UserAddBoosterModalComponent,
    UserTransactionsTabComponent,
    UserMatchsTabComponent,
    UserLogsTabComponent,
    UserSessionsTabComponent,
    UserLeaguesTabComponent,
    UserTournamentsTabComponent,
    UserMessagesTabComponent,
    UserReportsTabComponent,
    UserCollectionsTabComponent,]
})
export class UserDetailsComponent implements OnInit, AfterViewInit {

  isLoading: boolean = false;

  @ViewChild('userTabs', { static: false }) public userTabs!: TabsetComponent;
  @ViewChild('userEditModal') public userEditModal!: ModalDirective;
  @ViewChild('editNicknameModal') public editNicknameModal!: ModalDirective;
  @ViewChild('addExperienceModal') public addExperienceModal!: UserAddExperienceModalComponent;
  @ViewChild('addCurrencyModal') public addCurrencyModal!: UserAddCurrencyModalComponent;
  @ViewChild('addBoosterModal') public addBoosterModal!: UserAddBoosterModalComponent;
  @ViewChild('transactionTab') public transactionTab!: UserTransactionsTabComponent;
  @ViewChild('matchTab') public matchTab!: UserMatchsTabComponent;
  @ViewChild('logsTab') public logsTab!: UserLogsTabComponent;
  @ViewChild('sessionsTab') public sessionsTab!: UserSessionsTabComponent;
  @ViewChild('leaguesTab') public leaguesTab!: UserLeaguesTabComponent;
  @ViewChild('tournamentsTab') public tournamentsTab!: UserTournamentsTabComponent;
  @ViewChild('messagesTab') public messagesTab!: UserMessagesTabComponent;
  @ViewChild('reportsTab') public reportsTab!: UserReportsTabComponent;
  @ViewChild('collectionsTab') public collectionsTab!: UserCollectionsTabComponent;

  userId!: number;
  userTabStartIndex!: number;

  // USER DETAILS
  user: User = new User();
  isUserEditLoading: Boolean = false;

  protected readonly UserCurrencyType = UserCurrencyType;
  protected readonly UserBoosterType = UserBoosterType;
  protected readonly UserAccountType = UserAccountType;
  protected readonly isNaN = isNaN;

  isUserDetailsLevelOpen: boolean = false;
  isUserDetailsCurrencyOpen: boolean = false;
  isUserDetailsBoostersOpen: boolean = false;
  isUserDetailsStatisticsOpen: boolean = false;
  isUserDetailsTagsOpen: boolean = false;

  // USER EDIT
  editedNickname: string = '';

  constructor(public dateService: DateService, public apiUsersService: ApiUsersService, private alertsService: AlertsService, private route: ActivatedRoute,
    private modalsService: ModalsService) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const id: string = params['id'];

      if (id) {
        this.userId = Number(id);
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.userTabStartIndex) {
        this.userTabs.tabs[this.userTabStartIndex].active = true;
      }
    });
  }

  onSelectTabDetails(data: TabDirective): void {
    this.refreshUser();
  }

  // onSelectTabHistoric(data: TabDirective): void {
  //   this.refreshUserGamesHistory();
  // }

  // onSelectTabTournaments(data: TabDirective): void {
  //   this.refreshTournamentDateUsers();
  // }

  openAddExperienceModal() {
    this.addExperienceModal.show(() => this.refreshUser());
  }

  openEditNicknameModal() {
    this.editedNickname = this.user.firstname ?? '';
    this.isUserEditLoading = false;
    this.editNicknameModal.show();
  }

  saveEditNickname() {
    this.isUserEditLoading = true;
    this.apiUsersService.editUserNickname(this.userId, this.editedNickname).then(
      () => {
        this.isUserEditLoading = false;
        this.editNicknameModal.hide();
        this.alertsService.displayAlertSuccess('Nickname updated !');
        this.refreshUser();
      }, error => {
        this.isUserEditLoading = false;
        this.alertsService.displayAlertError('Error updating nickname : ' + error);
      }
    );
  }

  openUserUpdateCurrencyModal() {
    this.addCurrencyModal.show(() => this.refreshUser());
  }

  openAddBoosterModal() {
    this.addBoosterModal.show(() => this.refreshUser());
  }

  onSelectTabTransactions(): void {
    this.transactionTab.load();
  }

  onSelectTabMatchs(): void {
    this.matchTab.load();
  }

  onSelectTabLogs(): void {
    this.logsTab.load();
  }

  onSelectTabSessions(): void {
    this.sessionsTab.load();
  }

  onSelectTabLeagues(): void {
    this.leaguesTab.load();
  }

  onSelectTabTournaments(): void {
    this.tournamentsTab.load();
  }

  onSelectTabMessages(): void {
    this.messagesTab.load();
  }

  onSelectTabReports(): void {
    this.reportsTab.load();
  }

  onSelectTabCollections(): void {
    this.collectionsTab.load();
  }

  onClickRestoreUser(): void {
    this.modalsService.showConfirmModal(() => {
      this.apiUsersService.restoreUser(this.userId).then(
        () => {
          this.alertsService.displayAlertSuccess('User restored !');
          this.refreshUser();
        }, error => {
          this.alertsService.displayAlertError('Error restoring user : ' + error);
        }
      );
    });
  }

  onClickDeleteUser(): void {
    this.modalsService.showConfirmModal(() => {
      this.apiUsersService.deleteUser(this.userId).then(
        () => {
          this.alertsService.displayAlertSuccess('User deleted !');
          this.refreshUser();
        }, error => {
          this.alertsService.displayAlertError('Error deleting user : ' + error);
        }
      );
    });
  }

  onClickBanUser(): void {
    this.modalsService.showConfirmModal(() => {
      this.apiUsersService.changeUserBanState(this.userId, true).then(
        () => {
          this.alertsService.displayAlertSuccess('User banned !');
          this.refreshUser();
        }, error => {
          this.alertsService.displayAlertError('Error banning user : ' + error);
        }
      );
    });
  }

  onClickUnbanUser(): void {
    this.modalsService.showConfirmModal(() => {
      this.apiUsersService.changeUserBanState(this.userId, false).then(
        () => {
          this.alertsService.displayAlertSuccess('User unbanned !');
          this.refreshUser();
        }, error => {
          this.alertsService.displayAlertError('Error unbanning user : ' + error);
        }
      );
    });
  }

  refreshUser() {
    this.apiUsersService.getUser(this.userId).then(
      (user: User) => {
        this.user = user;
      }
    );
  }
}
